import { normalizeGeneratedFileContent } from './generatedFileContent.js'

function safeJsonParse(value) {
  try {
    return JSON.parse(value)
  } catch {
    return null
  }
}

export function applyAetherFileEvent(acc, event) {
  if (event?.type !== 'file_change' || !event.content) return
  const parsed = safeJsonParse(event.content)
  if (!parsed?.path) return
  acc.files.set(parsed.path, {
    path: parsed.path,
    content: normalizeGeneratedFileContent(parsed.content),
    operation: parsed.operation || 'create',
  })
}
